import { render, staticRenderFns } from "./ModalAddPatient.vue?vue&type=template&id=ea231420&scoped=true"
import script from "./ModalAddPatient.vue?vue&type=script&lang=js"
export * from "./ModalAddPatient.vue?vue&type=script&lang=js"
import style0 from "./ModalAddPatient.vue?vue&type=style&index=0&id=ea231420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea231420",
  null
  
)

export default component.exports